import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IPricingCardContent {
  labelIcon: string;
  labelText: string;
  title: string;
  paragraphs: React.ReactNode[];
  mobileSummary: React.ReactNode;
  cardType: 'sale' | 'buy';
}

export interface IPricingSectionProps {
  cards: IPricingCardContent[];
  ctaLabel: string;
  chevronIcon: string;
  onCardClick: (cardType: 'sale' | 'buy') => void;
  onCtaClick: () => void;
}

export const PricingSection: React.FC<IPricingSectionProps> = ({
  cards,
  ctaLabel,
  chevronIcon,
  onCardClick,
  onCtaClick,
}) => (
  <section className={`${styles['pricing-section']} reveal`} aria-label="Стоимость услуг">
    <div className={styles['pricing']}>
      <h2 className={`${styles['pricing__title']} text-primary`}>Сколько стоят услуги наших&nbsp;партнёров</h2>
      <div className={styles['pricing__cards']}>
        {cards.map(card => (
          <article
            key={card.title}
            className={styles['pricing-card']}
            role="button"
            tabIndex={0}
            onClick={() => onCardClick(card.cardType)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onCardClick(card.cardType);
              }
            }}
            data-modal-open
          >
            <div className={styles['pricing-card__row']}>
              <div className={styles['pricing-card__text']}>
                <span className={`${styles['pricing-card__label']} body2`}>
                  <img className={styles['pricing-card__icon']} src={card.labelIcon} alt="" />
                  {card.labelText}
                </span>
                <h3 className="text-primary">{card.title}</h3>
                {card.paragraphs.map((p, i) => (
                  <span key={i} className="body1">
                    <UIText1 color="text-primary-default">{p}</UIText1>
                  </span>
                ))}
                <span className={`${styles['pricing-card__mobile']} body1`}>
                  <UIText1 color="text-primary-default">{card.mobileSummary}</UIText1>
                </span>
              </div>
              <span className={styles['pricing-card__chevron']} aria-hidden="true">
                <img src={chevronIcon} alt="" />
              </span>
            </div>
          </article>
        ))}
      </div>
      <button
        className={`${styles['btn']} ${styles['btn--primary']} ${styles['pricing__cta']}`}
        type="button"
        onClick={onCtaClick}
        data-modal-open
      >
        <span className={styles['btn__text']}>{ctaLabel}</span>
      </button>
    </div>
  </section>
);
